module.exports = __webpack_public_path__ + "img/Monte_Kope_26.7bae7e18.jpg";